(function(){
 'use strict';
 function initShowcase(){
  document.querySelectorAll('.creator-showcase').forEach(function(section){
   if(section.dataset.creatorReady) return; section.dataset.creatorReady='true';
   var modal=section.parentElement.querySelector('[data-influencer-modal]');
   var cards=Array.from(section.querySelectorAll('[data-inf]:not([aria-hidden="true"])'));
   var videos=Array.from(section.querySelectorAll('video'));
   var preference=window.matchMedia('(prefers-reduced-motion: reduce)');
   var paused=preference.matches, visible=false;
   function sync(){
    var stopped=paused||!visible||document.hidden||!!(modal&&modal.classList.contains('is-open'));
    section.classList.toggle('is-motion-paused',stopped);
    videos.forEach(function(video){
     var rect=video.getBoundingClientRect();
     if(stopped||rect.right<=0||rect.left>=window.innerWidth||rect.bottom<=0||rect.top>=window.innerHeight) video.pause();
     else {var play=video.play();if(play&&play.catch)play.catch(function(){});}
    });
   }
   cards.forEach(function(card){
    var data;try{data=JSON.parse(card.dataset.inf);}catch(e){return;}
    card.setAttribute('role','button');card.tabIndex=0;
    card.setAttribute('aria-label','Watch '+data.name+'’s video');
    card.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();card.click();}});
    card.addEventListener('focus',function(){if(card.matches(':focus-visible')){section.classList.add('is-keyboard-browsing');card.scrollIntoView({block:'nearest',inline:'center'});}});
   });
   section.addEventListener('focusout',function(e){if(!section.contains(e.relatedTarget))section.classList.remove('is-keyboard-browsing');});
   section.addEventListener('pointerdown',function(){section.classList.remove('is-keyboard-browsing');});
   if(modal){
    modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');modal.setAttribute('aria-label','Creator video');
    modal.setAttribute('aria-hidden','true');modal.inert=true;
    section.addEventListener('click',function(e){
     var card=e.target.closest('[data-inf]');if(!card)return;
     modal.inert=false;modal.setAttribute('aria-hidden','false');
     var follow=modal.querySelector('[data-influencer-modal-follow]');
     try{var data=JSON.parse(card.dataset.inf);if(follow)follow.hidden=!data.profileUrl||data.profileUrl==='#';}catch(err){}
    },true);
    new MutationObserver(function(){
     var open=modal.classList.contains('is-open');modal.inert=!open;modal.setAttribute('aria-hidden',String(!open));
     sync();
    }).observe(modal,{attributes:true,attributeFilter:['class']});
    var player=modal.querySelector('[data-influencer-modal-video]');if(player)player.controls=true;
   }
   preference.addEventListener('change',function(e){paused=e.matches;sync();});
   document.addEventListener('visibilitychange',sync);
   new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;sync();},{threshold:0}).observe(section);
   new IntersectionObserver(sync,{threshold:0.1}).observe(section.querySelector('[data-influencer-track]'));
   videos.forEach(function(video){new IntersectionObserver(sync,{threshold:0.1}).observe(video);});
   sync();
  });
 }
 function init(){
  initShowcase();
  document.querySelectorAll('[data-creator-embed]').forEach(function(panel){
   if(panel.dataset.initialized) return; panel.dataset.initialized='true';
   var help=panel.parentElement.querySelector('[data-creator-form-help]');
   panel._ready=false;
   setTimeout(function(){if(!panel._ready&&help) help.hidden=false;},10000);
  });
  if(!document.querySelector('[data-creator-embed]')) return;
  var src='https://embed.typeform.com/next/embed.js';
  if(!document.querySelector('script[src="'+src+'"]')){var script=document.createElement('script');script.src=src;script.async=true;script.onerror=function(){document.querySelectorAll('[data-creator-form-help]').forEach(function(n){n.hidden=false;});};document.head.appendChild(script);}
  else if(window.tf&&window.tf.load) window.tf.load();
 }
 window.aykahCreatorFormReady=function(){document.querySelectorAll('[data-creator-embed]').forEach(function(panel){panel._ready=true;var help=panel.parentElement.querySelector('[data-creator-form-help]');if(help)help.hidden=true;});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
